// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  connectAuthEmulator,
  initializeAuth,
  indexedDBLocalPersistence,
  inMemoryPersistence,
  getAuth,
  signInWithEmailAndPassword,
  signOut
} from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";

export const FIREBASE_EMULATOR_PROJECT_ID = "demo-enrollease";
export const useFirebaseEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true";
const emulatorHost = process.env.REACT_APP_FIREBASE_EMULATOR_HOST;

if (useFirebaseEmulators && (!emulatorHost || emulatorHost.includes("://") || emulatorHost.includes("/"))) {
  throw new Error(
    "Emulator mode requires REACT_APP_FIREBASE_EMULATOR_HOST to be a host name or IP address."
  );
}

const firebaseConfig = {
  apiKey: "AIzaSyCd6cXt8w5pXkEE6KKmX1Elqm9pn-mNA60",
  authDomain: "enrollease-19c30.firebaseapp.com",
  databaseURL: "https://enrollease-19c30-default-rtdb.firebaseio.com",
  projectId: useFirebaseEmulators ? FIREBASE_EMULATOR_PROJECT_ID : "enrollease-19c30",
  storageBucket: "enrollease-19c30.firebasestorage.app",
  messagingSenderId: "286529913660",
  appId: "1:286529913660:web:c1d8b0486edbe9c52e5439",
  measurementId: "G-JLD9V97X09"
};

const app = getApps().find((instance) => instance.name === "[DEFAULT]") || initializeApp(firebaseConfig);
if (useFirebaseEmulators && app.options.projectId !== FIREBASE_EMULATOR_PROJECT_ID) {
  throw new Error("Emulator mode cannot use an already initialized non-demo Firebase project.");
}

const firestore = getFirestore(app);
export const defaultAuth = getAuth(app);
if (useFirebaseEmulators) {
  connectFirestoreEmulator(firestore, emulatorHost, 8080);
  connectAuthEmulator(defaultAuth, `http://${emulatorHost}:9099`, { disableWarnings: true });
}

function getOrInitializeAuth(appName, persistence) {
  const existingApp = getApps().find((instance) => instance.name === appName);
  const roleApp = existingApp || initializeApp(firebaseConfig, appName);
  const auth = existingApp ? getAuth(roleApp) : initializeAuth(roleApp, { persistence });
  if (useFirebaseEmulators) {
    connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });
  }
  return auth;
}

export const registrarAuth = getOrInitializeAuth("auth-registrar", indexedDBLocalPersistence);
export const admissionAuth = getOrInitializeAuth("auth-admission", indexedDBLocalPersistence);
export const financeAuth = getOrInitializeAuth("auth-finance", indexedDBLocalPersistence);
export const roomManagerAuth = getOrInitializeAuth("auth-room-manager", indexedDBLocalPersistence);
export const systemAdministratorAuth = getOrInitializeAuth("auth-system-administrator", indexedDBLocalPersistence);
export const deanAuth = getOrInitializeAuth("auth-dean", indexedDBLocalPersistence);
export const programHeadAuth = getOrInitializeAuth("auth-program-head", indexedDBLocalPersistence);
export const professorAuth = getOrInitializeAuth("auth-professor", indexedDBLocalPersistence);
export const vicePresidentAuth = getOrInitializeAuth("auth-vice-president", indexedDBLocalPersistence);
export const studentAuth = getOrInitializeAuth("auth-new-student", indexedDBLocalPersistence);
export const accountCreationAuth = getOrInitializeAuth("auth-account-creation", inMemoryPersistence);
export const loginVerifierAuth = getOrInitializeAuth("auth-login-verifier", inMemoryPersistence);
if (useFirebaseEmulators) {
  for (const firebaseApp of getApps()) {
    connectStorageEmulator(getStorage(firebaseApp), emulatorHost, 9199);
  }
} else {
  getAnalytics(app);
}

export function getCloudFunctionUrl(functionName) {
  if (!/^[A-Za-z][A-Za-z0-9]*$/.test(functionName)) {
    throw new Error("Invalid Cloud Function name.");
  }
  if (useFirebaseEmulators) {
    if (!emulatorHost) throw new Error("Emulator mode is enabled but its host is not configured.");
    return `http://${emulatorHost}:5001/${FIREBASE_EMULATOR_PROJECT_ID}/us-central1/${functionName}`;
  }
  return `https://us-central1-enrollease-19c30.cloudfunctions.net/${functionName}`;
}

export async function authenticateFirestoreClient(email, password, expectedUid) {
  const credential = await signInWithEmailAndPassword(defaultAuth, email, password);
  if (credential.user.uid !== expectedUid) {
    await signOut(defaultAuth);
    throw new Error("The Firestore session does not match the verified account.");
  }
  return credential.user;
}

export default app;